import type { IconData } from '@stacksjs/iconify-core'

export const shieldHalf: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m8 2.136l-6 2.25V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342zm-7.351.62L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shieldHalf
